import { tokens } from '@hotjar/hotsauce';
import { Icon } from '@hotjar/webapp/components/Icon';

export function ThumbsUpDownTableIcon({ color }: { color?: string }): JSX.Element {
  return <Icon icon="thumbs-up-down" size={16} color={color || tokens.color.text_default} />;
}
